var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('herder',{attrs:{"msg":"智慧煤矿三维可视化系统"}}),_c('littleleft'),_vm._v(" "),_c('buttomxp'),_vm._v(" "),_c('rightlittle'),_vm._v(" "),_c('rightlist'),_vm._v(" "),_c('zyd')],1)}
var staticRenderFns = []

export { render, staticRenderFns }